import { Minus, Plus } from '@styled-icons/boxicons-regular';
import { useState } from 'react';
import styled, { css } from 'styled-components';

import WysiwygText from '~/components/WysiwygText';
import { colors } from '~/utils/css-mixins';

const Wrapper = styled.div`
  margin-top: 20px;
`;

const StyledHeading = styled.h2`
  font-size: 23px;
`;

const Ul = styled.ul`
  li:not(:last-child) {
    padding-bottom: 15px;
    border-bottom: 1px solid ${colors.border};
  }
`;

const Li = styled.li`
  margin-top: 15px;
  display: flex;
  position: relative;
  cursor: pointer;
`;

const InnerLi = styled.div`
  margin-left: 25px;

  > div {
    margin-top: 10px;
  }
`;

const IconStyles = css`
  width: 20px;
  fill: ${colors.primary};
  margin-right: 5px;
  position: absolute;
  top: 2px;
`;

const PlusIcon = styled(Plus)`
  ${IconStyles}
`;

const MinusIcon = styled(Minus)`
  ${IconStyles}
`;

const LiHeadline = styled.h4`
  font-size: 14px;
  text-align: start;
`;

const AccordionList = ({ content: { headline, contents } }) => {
  const [selected, setSelected] = useState(null);

  const toggle = i => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };

  return (
    <Wrapper>
      <StyledHeading>{headline}</StyledHeading>
      <Ul>
        {contents.map(({ headline, text }, index) => (
          <Li
            key={index}
            onClick={() => toggle(index)}
            active={selected === index}
          >
            {selected === index ? <MinusIcon /> : <PlusIcon />}
            <InnerLi>
              <button type="button">
                <LiHeadline>{headline}</LiHeadline>
              </button>
              {selected === index && <WysiwygText html={text} />}
            </InnerLi>
          </Li>
        ))}
      </Ul>
    </Wrapper>
  );
};

export default AccordionList;
